<script setup lang="ts"></script>

<template>
  <icon name="lucide:info" />
</template>

<style scoped></style>
